import React from 'react'

import StatsBar from '~/components/status-bar/StatusBar'
import RootLayout from '~/pages/layout'

interface Props {
  searchCount: number
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children, searchCount }) => {
  return (
    <RootLayout>
      <StatsBar isSearchPage noOfSearchResult={searchCount} />
      <main className='min-h-[calc(100vh-90px)] w-full bg-[#e2e8f0] pb-20 pt-36'>
        {children}
      </main>
    </RootLayout>
  )
}

export default Layout
